export default __webpack_public_path__ + "static/media/visual2.dea71694.png";